export const BASE_API_URL =  process.env.REACT_APP_API_KEY || 'http://golden-api.aegona.work'